var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.items,"item-text":"idmc_short_name","item-value":"iso3","label":"Countries","multiple":"","small-chips":"","return-object":false},on:{"change":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }